import { Flex, Text } from "@radix-ui/themes";
import { type ReactNode, type FC, type PropsWithChildren } from "react";

import { ReactComponent as Hero } from "../../images/login-hero.svg";
import { ReactComponent as Logo } from "../../images/Logotype.svg";

export const LoginLayout: FC<
  { customCaption?: ReactNode } & PropsWithChildren<any>
> = ({ children }) => {
  return (
    <section className="flex min-h-screen w-full items-start justify-center bg-puntt-neutral-gray-3 p-0 sm:px-1 sm:py-9 md:px-8">
      <div className="w-full md:flex md:items-start md:justify-between md:gap-16 lg:justify-center">
        {/* Left Column - Login Form */}
        <article className="w-full rounded-2xl md:w-[40vw] md:min-w-[320px] md:max-w-[300px] md:basis-3/5 lg:basis-auto">
          <Flex
            direction="column"
            gap={{ initial: "4", sm: "5" }}
            className="w-full bg-puntt-neutral-gray-3 p-6 sm:rounded-lg sm:bg-base-white sm:py-10 sm:shadow-md"
          >
            <Logo className="mx-auto h-auto w-[160px]" />
            <hr className="hidden border-puntt-neutral-grayA-6 sm:block" />
            {children}
          </Flex>
        </article>

        {/* Right Column - Carousel */}
        <article className="bg-white hidden w-[40vw] min-w-[320px] max-w-[512px] md:block">
          <Flex direction="column" gap="5" className="my-10 w-full">
            <Flex direction="column" gap="2" className="text-center">
              <Text as="div" size="7" weight="bold">
                Move Fast. Stay Compliant.
              </Text>
              <Text as="div" size="4">
                AI agents automate reviews for
                <br />
                creative, legal, and packaging content.
              </Text>
            </Flex>
            <Hero className="translate-y-[-25px] [clip-path:inset(25px_0_0_0)]" />
          </Flex>
        </article>
      </div>
    </section>
  );
};
